module.exports = __webpack_public_path__ + "img/女-胰腺癌h.df7cf157.png";